import {Component, Input} from '@angular/core';
import {ExampleSJ} from "../../models/word.model";
import {IsHanja} from "../../defines/common.func";

export type ExampleCharInfo = {
  text: string;
  seungjoCss: string;
  textCss: string;
  highlightCss: string;
};

@Component({
  selector: 'app-example-disp',
  templateUrl: './example-disp.component.html',
  styleUrls: ['./example-disp.component.scss']
})
export class ExampleDispComponent {
  @Input() public compact = false;

  words: Array<Array<ExampleCharInfo>> = [];

  private _exampleSJ: ExampleSJ | null = null;

  @Input()
  set exampleSJ(value: ExampleSJ | null) {
    this._exampleSJ = value;
    this.words = this.parseWords(value);
  }

  get exampleSJ(): ExampleSJ | null {
    return this._exampleSJ;
  }

  get compactText(): string {
    return this.exampleSJ?.example?.replace(/\//g, ' ') ?? '';
  }

  private parseWords(sj: ExampleSJ | null): Array<Array<ExampleCharInfo>> {
    if (!sj?.example) return [];

    const chars = Array.from(sj.example);
    const words: Array<Array<ExampleCharInfo>> = [];
    let currentWord: Array<ExampleCharInfo> = [];

    chars.forEach((c, i) => {
      const info: ExampleCharInfo = {
        text: c === '/' ? ' ' : c,
        seungjoCss: (c !== ' ' && sj.seungjo?.[i]) ? `ic-intonation-${sj.seungjo[i]}` : '',
        textCss: c === ' ' ? 'space' : c === '/' ? 'slash' : c === ':' ? 'jangdan' : IsHanja(c) ? 'hanja-size' : '',
        highlightCss: this.getHighlightCss(sj.highlight?.[i]),
      };

      if (c === ' ') {
        if (currentWord.length > 0) {
          currentWord.push(info);
          words.push(currentWord);
          currentWord = [];
        } else if (words.length > 0) {
          words[words.length - 1].push(info);
        }
      } else {
        currentWord.push(info);
      }
    });

    if (currentWord.length > 0) {
      words.push(currentWord);
    }

    return words;
  }

  /**
   * 예문 강조 마스크 값(글자 1자리)을 word-disp와 동일한 강조 클래스로 변환한다.
   * '1' → highlight(색상), '2' → highlight2(기울임), 그 외/누락 → 강조 없음.
   */
  private getHighlightCss(mark: string | undefined): string {
    switch (mark) {
      case '1':
        return 'highlight';
      case '2':
        return 'highlight2';
      default:
        return '';
    }
  }
}
